<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-recovery">
        <div class="vx-col sm:w-full md:w-1/4 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" style="background-color:rgb(244, 244, 244)">
                    <div class="vx-row no-gutter justify-center items-center">
                        <!-- <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/login.png" alt="Intelliprice" class="mx-auto" style="width:100%">
                        </div> -->
                        <div class="vx-col sm:w-full md:w-full ml-auto mr-auto d-theme-dark-bg">
                            <div class="py-20 px-10 login-tabs-container">
                                <img src="@/assets/images/logo/login_logo.png" alt="Intelliprice" class="align-left mb-20" style="width:220px">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Επαναφορά συνθηματικού</h4>
                                    <p>Παρακαλούμε εισάγετε το e-mail σας και θα σας στείλουμε πληροφορίες για να ολοκληρώσετε την επαναφορά του κωδικού σας.</p>
                                </div>
                                <vs-input type="email" label-placeholder="E-mail"  v-model="email" class="w-full mb-8" />
                                <div class="error" v-if="initiated && !((/^([\w!.%+\-\*])+@([\w\-])+(?:\.[\w\-]+)+$/).test(email))"><i>Παρακαλώ εισάγετε ένα έγκυρο email.</i></div>
                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Επιστροφή</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" :disabled="completed" @click="checkMail()">Επαναφορά</vs-button>
                                <vs-alert class="mt-5" v-if="message">{{message}}</vs-alert>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";

export default {
  data () {
    return {
        email: '',
        wrongFormat:false,
        initiated:false,
        message: '',
        completed:false
    }
  },
    methods: {
      checkMail()
      {
          let vm = this;
          vm.initiated = true;
          vm.message = '';

          if(!((/^([\w!.%+\-\*])+@([\w\-])+(?:\.[\w\-]+)+$/).test(vm.email))) {
              vm.wrongFormat = true;
              return;
          } else {
              vm.wrongFormat = false;
          }

          vm.$vs.loading();
          axios.defaults.baseURL = localStorage.getItem('apiEndpoint');

          axios.post("recovery", { 'email': vm.email})
              .then((response) => {
                  if(response.data.error) {
                      vm.message = response.data.message;
                  } else {
                      vm.message = response.data.message;
                      vm.completed = true;
                  }
                  vm.$vs.loading.close();
              })
              .catch((error) => {
                  vm.$vs.loading.close();
              })

      }
    }
}
</script>
<style>
    .error {
        color: #980b0b;
        margin-bottom:20px;
    }
</style>
